import { createI18n } from "vue-i18n";
import zhTW from "vxe-table/lib/locale/lang/zh-TW";

const messages = {
  zh_TW: {
    ...zhTW,
  },
};

const i18n = createI18n({
  locale: "zh_TW",
  messages,
});

export default i18n;
